export default __webpack_public_path__ + "static/media/Drums.28aeac6a.png";